export default __webpack_public_path__ + "4e8a0ae246123a4d95f4f2d584278ef7.svg";